function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'underscore';
import moment from 'moment';
import { constantsRegistry } from '../constants/tableConstantsFactory';
import entityActionFactory from './factories/entityActionFactory';
import store from '../reducers/storeRegistration';
const entityActions = entityActionFactory('cabinetFilterOptions', 'cabinetFilterOptions');
const cabinetFilterOptionsConstants = constantsRegistry('cabinetFilterOptions');

/**
 *  Get the options index query, in the store under cabinet.<cabinet identifier>.<filter index>
 */
const getOptionsIndexQuery = (cabinet, filterIndex) => {
  var _cabinetStore$cabinet;
  let cabinetOptionsIndexQuery = null;
  const cabinetStore = store.getState().cabinetFilterOptions || {};
  if ((_cabinetStore$cabinet = cabinetStore[cabinet]) !== null && _cabinetStore$cabinet !== void 0 && _cabinetStore$cabinet[filterIndex]) {
    cabinetOptionsIndexQuery = cabinetStore[cabinet][filterIndex].indexQuery;
  }

  // if not initialized, set the options index query to the base cabinet.initialIndexQuery
  if (cabinetStore && !cabinetOptionsIndexQuery) {
    cabinetOptionsIndexQuery = _objectSpread(_objectSpread({}, cabinetStore.initialIndexQuery), {}, {
      cabinet,
      filterIndex
    });
  }
  return cabinetOptionsIndexQuery;
};

/**
 *  Pull out the filter option's indexQuery from cabinetFilterOptions state and call entityActions
 *
 *  Infinite scroll can ask for the next page before the first request has stored options for
 *  this filter, so a missing slice means there is nothing to page rather than an error.
 */
const pageNext = (cabinetIdentifier, filterIndex) => async dispatch => {
  var _cabinetStore$cabinet2;
  const cabinetStore = store.getState().cabinetFilterOptions || {};
  const {
    hasNext
  } = ((_cabinetStore$cabinet2 = cabinetStore[cabinetIdentifier]) === null || _cabinetStore$cabinet2 === void 0 ? void 0 : _cabinetStore$cabinet2[filterIndex]) || {};
  if (hasNext) {
    const cabinetOptionsIndexQuery = getOptionsIndexQuery(cabinetIdentifier, filterIndex);
    await dispatch(entityActions.pageNext(cabinetOptionsIndexQuery));
  }
};

/**
 *  Store the current cabinet and filter in state, which can be read by the index
 *  success reducer to put data in the proper place
 */
const setCurrentCabinetFilter = (currentCabinet, currentFilter) => ({
  type: cabinetFilterOptionsConstants.SET_CURRENT,
  currentCabinet,
  currentFilter
});

/**
 *  Custom serverFilter implementation to fetch the indexQuery of individual filter options
 *  stored in redux state under cabinetFilterOptions[cabinetIdentifier][filterIndex]
 */
const serverFilter = (cabinetIdentifier, filterIndex, filters) => async dispatch => {
  // ALWAYS set currentCabinet/currentFilter BEFORE making the request.
  // This ensures the reducer knows where to store results when INDEX_SUCCESS fires.
  // We must await this to ensure the reducer processes SET_CURRENT before INDEX is dispatched.
  await dispatch(setCurrentCabinetFilter(cabinetIdentifier, filterIndex));
  const cabinetOptionsIndexQuery = getOptionsIndexQuery(cabinetIdentifier, filterIndex);
  await dispatch(entityActions.serverFilter(filters, cabinetOptionsIndexQuery));
  return null;
};

/**
 *  Custom serverIndex implementation to check the indexQuery of individual filter options
 *  stored in redux state under cabinetFilterOptions[cabinetIdentifier][filterIndex]
 */
const serverIndex = (cabinetIdentifier, filterIndex, indexQuery) => async dispatch => {
  const cabinetFilterOptionsStore = store.getState().cabinetFilterOptions;
  if (cabinetFilterOptionsStore.currentCabinet !== cabinetIdentifier || cabinetFilterOptionsStore.currentFilter !== filterIndex) {
    dispatch(setCurrentCabinetFilter(cabinetIdentifier, filterIndex));
  }
  const cabinetOptionsIndexQuery = getOptionsIndexQuery(cabinetIdentifier, filterIndex);

  // check for expiration before sending to entityActions.serverIndex since that
  // code uses the default `cabinetFilterOptions` state to look for the indexQuery
  // rather than the cabinet[cabinetIdentifier][filterIndex] state
  if (indexQuery.initialized && _.isEqual(indexQuery, cabinetOptionsIndexQuery) && moment().isBefore(moment.unix(indexQuery.expiration), 'minute')) {
    return null;
  }
  return dispatch(entityActions.serverIndex(cabinetOptionsIndexQuery));
};
const cabinetFilterOptionsActions = {
  pageNext,
  serverFilter,
  serverIndex
};
export default cabinetFilterOptionsActions;